import React, {useState} from 'react'
import AppLayout from '@/Layouts/AppLayout'
import useLang from "@/Hooks/useLang";
import Text from "@/Components/Front/Text";
import DataScience from "@/Components/Front/SVGS/Services/DataScience";
import {Head, Link} from "@inertiajs/inertia-react";
import ChevronRight from "@/Components/Front/SVGS/ChevronRight";
import LineaData2 from "@/Components/Front/SVGS/LineaData2";
import ArrowBack from "@/Components/Front/SVGS/ArrowBack";
import Masonry from "react-masonry-css";
import Header from "@/Components/Front/Header";
import Corner from "@/Components/Front/SVGS/Corner";
import Gad from "@/Components/Front/PNGS/grad-ma.png";
import Generation from "@/Components/Front/SVGS/Services/Generation";
import {useMediaQuery} from "react-responsive";
import ChevronRightAlt from "@/Components/Front/SVGS/ChevronRightAlt";

export default function ServicesAvailable(props) {

    const [lang, setLang] = useLang(props.locale);


    const textProps = {
        lang: lang, language: props.language,
    };
    const isMobile = useMediaQuery({query: '(max-width: 639px)'});
    const isMobileAndTabletPortrait = useMediaQuery({query: '(max-width: 1023px)'});
    const isSm = useMediaQuery({query: '(min-width: 640px)'})
    const isMd = useMediaQuery({query: '(min-width: 768px)'})
    const isLg = useMediaQuery({query: '(min-width: 1024px)'})
    const isXl = useMediaQuery({query: '(min-width: 1366px)'})
    const is2Xl = useMediaQuery({query: '(min-width: 1800px)'})
    const is3Xl = useMediaQuery({query: '(min-width: 2400px)'})

    return (
        <>



            <Header textProps={textProps} locale={lang} language={props.language} setLang={setLang} activeItem={"services-available"}/>

            <section id="data-science" className={"services-page generation"}>
                {isMobileAndTabletPortrait &&

                    <>
                        <div className={"back-arrow"}>
                            <Link href={"/"}>
                                <ChevronRightAlt/>
                            </Link>
                        </div>
                        <div className={"mobile-image"}>
                            <img src="images/Generation.svg" alt=""/>

                        </div>
                    </>
                }
                <div className="in-frame-inner">
                    {/*<div className={"section-gradient"}>*/}
                    {/*    <img src={Gad} alt=""/>*/}
                    {/*</div>*/}

                    {isLg &&
                        <div className={"section-background"}>

                            <Generation/>
                        </div>
                    }

                    <div className={"section-title"}>
                        <div className={"service-icon"}>
                            <LineaData2/>
                        </div>
                        <div className={"service-back-button"}>
                            <Link href={"/"}>
                                <ArrowBack/>
                            </Link>
                        </div>
                        <h1>
                            <span><Text {...textProps} str={"data-generation-title-1"}/></span>
                            <span><Text {...textProps} str={"data-generation-title-2"}/></span>
                        </h1>
                        <p>
                            <Text {...textProps} str={"data-generation-text-0"} html={true}/>

                        </p>


                    </div>
                    <div className="video-responsive">
                        {/*{lang && props.language &&*/}
                        {/*    <iframe*/}
                        {/*        width="853"*/}
                        {/*        height="480"*/}
                        {/*        src={`https://www.youtube.com/embed/` + props.language[lang]['data-generation-video-id']}*/}
                        {/*        frameBorder="0"*/}
                        {/*        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"*/}
                        {/*        allowFullScreen*/}
                        {/*        title="Embedded youtube"*/}
                        {/*    />*/}
                        {/*}*/}
                        <img src="images/data.jpg" alt=""/>
                    </div>



                    <div className={"services-data-container"}>


                        <p>
                            <Text {...textProps} str={"data-generation-text-1"} html={true}/>
                        </p>
                        <p>
                            <Text {...textProps} str={"data-generation-text-2"} html={true}/>
                        </p>
                        <p>

                        </p>
                    </div>





                    <div className={"back-button"}>
                        <Link href={"/"}>

                            <button>
                                <ChevronRight/> <Text {...textProps} str={"back"}/>
                            </button>
                        </Link>
                    </div>
                </div>
            </section>
</>
    )
}
